import script from "./LuuTruCongViec.vue?vue&type=script&setup=true&lang=js"
export * from "./LuuTruCongViec.vue?vue&type=script&setup=true&lang=js"

import "./LuuTruCongViec.vue?vue&type=style&index=0&id=ebb705f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebb705f0"]])

export default __exports__